import {WwsUmsatzstatistikOptionenListStore} from './abstractions/optionen-list.store';

export const WwsUmsatzstatistikUmsatzebeneStore = new WwsUmsatzstatistikOptionenListStore<{ umsatzebene: string; key: string }>()
